import $ from "jquery";
window.jQuery = $;
window.$ = $;

require("./shadow-scroller");
import "./accordion-menu";
import "./skipContent";
import "./toggleDrawer";
import "./review";
import "./progressBar";
import "./modal";
import "./disclosure";
import "./accordion";
import "./createStep";
import "./deleteStep";
import "./validateCapCreation";
import "./programSelect";
import "./validateFormPage";
import "./tooltip";
import "./toolkitSelect";
import "./addPartner";
import "./ldatSelection";
import "./selectedCheckbox";
import "./addProcess";
import "./updateProcessSelection";
import "./addbudget";
import "./updateTotalBudget";
import "./addActivityForm";
import "./clearActivity";
import "./deleteActivity";
import "./focusedActivity";
import "./updateToolkit";
import "./utils/textarea-cleanup";

(function ($) {
  "use strict";

  var site = (window.site = {});

  site.elements = {
    menu: $(".page-head-hamburger-menu"),
    sideMenu: $(".menu-side"),
    btnMenu: $(".btn-menu"),
    hamburgerMenu: $(".site-header__main-nav"),
    pageHead: "site-header",
  };

  site.getBreakpoint = (function () {
    var breakpoint;

    function getBreakpointContent() {
      return window
        .getComputedStyle(document.body, ":after")
        .content.toLowerCase()
        .replace(/"/g, "");
    }

    breakpoint = getBreakpointContent();
    $(window).resize(function () {
      breakpoint = getBreakpointContent();
    });

    return function () {
      return breakpoint;
    };
  })();

  /* Generate overlay */

  site.showDrawerOverlay = function () {
    $("body").addClass("toggled-drawer-offset-overlay");
  };

  site.hideDrawerOverlay = function () {
    $("body").removeClass("toggled-drawer-offset-overlay");
  };

  /* End of Generating overlay */

  /* Initializing shadow scroller */

  site.shadowScroller = function () {
    $(".item-page table").shadowScroller();
  };

  /* End of initializing shadow scroller */

  /* Reset rs form submit button when clickout outside of recaptcha */

  site.recaptcha = function () {
    $(document).mouseup(function (e) {
      var iframe = $('iframe[title="recaptcha"]');

      // if the target of the click outside of the recaptcha iframe

      if (!iframe.is(e.target) && iframe.has(e.target).length === 0) {
        $(".rsform-submit-button").each(function () {
          if ($(this).prop("disabled")) {
            $(this).removeProp("disabled");
          }
        });
      }
    });
  };

  /* End of reset rs form submit button when clickout outside of recaptcha */

  /* Initializing dropdown menu */

  site.accordionMenu = function (menu) {
    $(menu).accordionMenu({
      addIndicator: true,
      onlyOneShown: true,
      autoScroll: true,
    });
  };

  /* End of Initializing dropdown menu */

  /* Hamburger menu */

  site.hamburgerMenu = {
    isActive: false,

    close: function () {
      site.elements.hamburgerMenu.removeClass("active");
      site.elements.btnMenu.removeClass("active");
      if ($("body.drawer-open").length) {
        site.toggleDrawer.closeDrawer(
          $("[data-drawer-toggle='top-search-module']"),
          $("body")
        );
      }
      $("body").removeClass("menu-open drawer-open");
      $("html").removeClass("menu-open");
      site.hideDrawerOverlay();
      this.isActive = false;
    },

    open: function () {
      site.elements.hamburgerMenu.addClass("active");
      site.elements.btnMenu.addClass("active");
      if ($("body.drawer-open").length) {
        site.toggleDrawer.closeDrawer(
          $("[data-drawer-toggle='top-search-module']"),
          $("body")
        );
      }
      $("body").addClass("menu-open");
      $("html").addClass("menu-open");
      site.showDrawerOverlay();
      this.isActive = true;
    },

    init: function () {
      var that = this;
      site.elements.btnMenu.click(function (e) {
        e.preventDefault();
        that.isActive ? that.close() : that.open();
      });

      $(document).on("click touchend", function (e) {
        if (
          !$(e.target).closest("." + site.elements.pageHead).length &&
          that.isActive &&
          !$(e.target).closest(".site-header__main-nav").length
        ) {
          that.close();
        }
      });

      $(window).on("resize", function () {
        if (site.getBreakpoint() === "desktop" && that.isActive) {
          that.close();
        }
      });
    },
  };

  /* End of hamburger menu */

  site.searchModule = function () {
    var hasMoved = false;
    var searchModules = null;
    function moveSearchModule() {
      if (window.innerWidth < 767 && !hasMoved) {
        searchModules = $(".site-header__search-module");
        $(".page-head-hamburger-menu").prepend(searchModules);
        hasMoved = true;
      } else if (window.innerWidth >= 768 && hasMoved) {
        $(".site-header").after(searchModules);
        hasMoved = false;
      }
    }

    moveSearchModule();
    $(window).resize(function () {
      moveSearchModule();
    });
  };

  site.showPassword = function () {
    let srPasswordText = $("#password-text");
    $(".password-icon").on("click", function () {
      var passwordField = $(this);
      if (passwordField.hasClass("show")) {
        $(this).removeClass("show");
        $(this).attr("aria-pressed", false);
        $(this).attr("aria-label", "hide password");
        $(this).prev().attr("type", "password");
        srPasswordText.text("Password hidden");
      } else {
        $(this).addClass("show");
        $(this).attr("aria-pressed", true);
        $(this).attr("aria-label", "show password");
        srPasswordText.text("Password shown");
        $(this).prev().attr("type", "text");
      }
    });
  };

  site.dismissMessageTime = function () {
    if ($(".messages")) {
      setTimeout(function () {
        $(".messages").fadeOut(300, function () {
          $(this).remove();
        });
      }, 5000);
    }
  };

  site.closeMessage = function () {
    $(".messages .close-btn").on("click", function () {
      $(this).parent().remove();
    });
  };

  site.init = function () {
    site.shadowScroller();
    site.recaptcha();
    site.accordionMenu(site.elements.menu);
    site.accordionMenu(site.elements.sideMenu);
    site.hamburgerMenu.init();
    site.searchModule();
    site.showPassword();
    site.dismissMessageTime();
    site.closeMessage();
  };

  // Document ready

  $(function () {
    site.init();
  });
})($);
